import { Link } from "react-router-dom";
import { events, hotRankIds } from "@/mocks/events";

export default function Hero() {
  const featured = events[0];
  const ranked = hotRankIds
    .map((id) => events.find((e) => e.id === id))
    .filter((e): e is NonNullable<typeof e> => Boolean(e))
    .slice(0, 6);

  return (
    <section className="relative w-full overflow-hidden">
      <div
        className="absolute inset-0 -z-10 bg-cover bg-center opacity-[0.14]"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20illustration%20of%20a%20rising%20popularity%20trend%2C%20ascending%20flame%20and%20upward%20arrow%2C%20floating%20mobile%20phone%20screens%20hearts%20stars%20and%20speech%20bubbles%20around%20a%20glowing%20red-orange%20fire%2C%20on%20textured%20cream%20paper%20background%2C%20muted%20terracotta%20amber%20and%20ink%20palette%2C%20bold%20minimal%20flat%20shapes%2C%20magazine%20spread%20art%2C%20wide%20composition%2C%20lots%20of%20negative%20space%20in%20center&width=1600&height=900&seq=hero-bg-2026&orientation=landscape)",
        }}
      />

      <div className="container-x pt-10 pb-14 md:pt-16 md:pb-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          {/* Featured editorial */}
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-3 py-1 font-label text-xs font-medium text-background-50">
              <i className="ri-flashlight-fill text-sm" aria-hidden="true" />
              今日头条 · 走红事件
            </span>
            <Link to={`/shijian/${featured.id}`} className="group mt-6 block cursor-pointer">
              <h1 className="max-w-2xl font-heading text-3xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[2.6rem] md:leading-[1.2]">
                {featured.title}
              </h1>
            </Link>
            <p className="mt-5 max-w-2xl text-base leading-8 text-foreground-700 md:text-lg">
              {featured.excerpt}
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-3 text-sm text-foreground-600">
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-user-heart-line text-primary-500" aria-hidden="true" />
                {featured.person}
              </span>
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-calendar-line" aria-hidden="true" />
                {featured.date}
              </span>
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-fire-line text-primary-500" aria-hidden="true" />
                全网热度 {featured.heat}
              </span>
            </div>
            <Link
              to={`/shijian/${featured.id}`}
              className="mt-8 inline-flex items-center gap-2 rounded-md bg-background-950 px-5 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-foreground-950 cursor-pointer"
            >
              阅读走红全记录
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>

          {/* Hot rank panel */}
          <aside className="lg:col-span-5">
            <div className="card overflow-hidden bg-background-100/70">
              <div className="flex items-center justify-between border-b border-background-200 px-5 py-4">
                <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                  <i className="ri-fire-fill text-primary-500" aria-hidden="true" />
                  今日全网热榜
                </h2>
                <Link
                  to="/shijian"
                  className="font-label text-xs text-primary-600 transition-colors hover:text-primary-700 cursor-pointer"
                >
                  查看全部 <i className="ri-arrow-right-line" aria-hidden="true" />
                </Link>
              </div>
              <ol className="divide-y divide-background-200 px-5">
                {ranked.map((e, i) => (
                  <li key={e.id}>
                    <Link
                      to={`/shijian/${e.id}`}
                      className="group flex items-start gap-4 py-4 cursor-pointer"
                    >
                      <span
                        className={`mt-0.5 font-heading text-2xl font-black leading-none ${
                          i === 0
                            ? "text-primary-500"
                            : i === 1
                              ? "text-accent-600"
                              : i === 2
                                ? "text-secondary-600"
                                : "text-foreground-300"
                        }`}
                      >
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="flex-1">
                        <span className="block font-label text-[15px] leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                          {e.title}
                        </span>
                        <span className="mt-1.5 flex items-center gap-3 text-xs text-foreground-600">
                          <span className="inline-flex items-center rounded-sm bg-primary-100 px-1.5 py-0.5 text-primary-700">
                            {e.categoryLabel}
                          </span>
                          <span className="inline-flex items-center gap-1">
                            <i className="ri-fire-line" aria-hidden="true" />
                            {e.heat}
                          </span>
                        </span>
                      </span>
                    </Link>
                  </li>
                ))}
              </ol>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}